/* eslint-disable arrow-body-style */
/* eslint-disable import/no-named-as-default */
import api from './base.service';

export const getAllNotifications = (userId) => {
    return api().get(`/api/notifications/${userId}`);
};

export const archiveNotification = (guid) => {
    return api().patch(`/api/notifications/archived/${guid}`);
};

export const archiveAllNotifications = (userId) => {
    return api().patch(`/api/notifications/archived/all/${userId}`);
};
